import React from 'react';
export var useSingleExecutionFunction = function useSingleExecutionFunction(fn) {
  var hasRunRef = React.useRef(false);
  return function () {
    if (!hasRunRef.current) {
      fn.apply(void 0, arguments);
      hasRunRef.current = true;
    }
  };
};